export default __webpack_public_path__ + "static/media/img-b-end-bg@3x.774e70e3.jpg";